import useTranslation from 'common/hooks/useTranslation';
import { selectCurrentCompany } from 'common/slices/auth.slice';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';

const Breadcrumbs = () => {
  const params = useParams();
  const companySlug = params.companySlug;

  const currentCompany = useSelector(selectCurrentCompany);
  const location = useLocation();
  const { t } = useTranslation('common\\breadcrumbs');

  const segments = location.pathname.split('/').filter(Boolean).slice(1);

  const crumbs = [
    {
      label: currentCompany?.name || companySlug,
      to: '/',
    },
    ...segments.map((seg, idx) => ({
      label: t(seg.replace(/%20|-/g, ' ')) || seg.replace(/%20|-/g, ' '),
      to: `/${companySlug}/${segments.slice(0, idx + 1).join('/')}`,
    })),
  ];

  return (
    <nav className='flex items-center'>
      {crumbs.map(({ label, to }, i) => {
        const isLast = i === crumbs.length - 1;
        return isLast ? (
          <span key={to} className='font-semibold capitalize'>
            {label}
          </span>
        ) : (
          <React.Fragment key={to}>
            <Link
              to={to}
              className='text-cool-grey hover:underline cursor-pointer capitalize'
            >
              {label}
            </Link>
            <span className='px-1'>/</span>
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
